module.exports = __webpack_public_path__ + "img/no-search.96c77eef.svg";